<template>
  <div id="app">
    <v-app id="inspire">
      <v-app id="inspire">
        <v-app-bar app color="primary" dark>
          <v-toolbar-title>
            <router-link to="/" tag="span" exact :style="{ cursor: 'pointer'}">
              Сервис по определению мест концентрации ДТП
            </router-link>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="logout" v-if="loggedIn" class="mr-3"
            ><v-icon>fa-sign-out-alt</v-icon></v-btn
          >
        </v-app-bar>

        <v-main>
          <v-container fluid><router-view /></v-container>
        </v-main>
        <v-footer color="primary" app>
          <v-row justify="center">
            <v-col md="3"
              ><span class="white--text"
                >ГБУ "Безопасность дорожного движения"</span
              ></v-col
            >
            <v-col align="center" md="1"
              ><span class="white--text"
                >&copy; {{ new Date().getFullYear() }}</span
              ></v-col
            >
          </v-row>
        </v-footer>
      </v-app>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutUser").then(() => {
        this.$router.push("/");
      });
    },
  },
  created() {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function () {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logoutUser");
        }
        throw err;
      });
    });
  },
};
</script>

<style>
</style>
